import Icon from "@mui/material/Icon";

// Pages
import Contact from "layouts/pages/contact";
import Homepage from "layouts/pages/homepage";
import DesSpreNoi from "layouts/pages/des-spre-noi";
import GalleryPage from "pages/Gallery";
import Tarife from "pages/Tarife";
import BlogList from "pages/Blog/BlogList";

// Curățenie (nou meniu separat)
import CuratenieGenerala from "pages/Servicii/ServiciiCuratenie/CuratenieGenerala";
import CurateniePostConstruct from "pages/Servicii/ServiciiCuratenie/CurateniePostConstruct";
import CuratenieIntretinere from "pages/Servicii/ServiciiCuratenie/CuratenieIntretinere";
import CuratareMocheteCovoare from "pages/Servicii/ServiciiCuratenie/CuratareMocheteCovoare";
import CuratareSuprafeteVitrate from "pages/Servicii/ServiciiCuratenie/CuratareaSuprafetelorVitrate";
import CuratareaPardoselilor from "pages/Servicii/ServiciiCuratenie/CuratareaPardoselilor";
import TratamentePardoseli from "layouts/pages/servicii/ServiciiCuratenie/TratamentePardoseli";

// Servicii Speciale
import CuratenieVileApartamente from "layouts/pages/servicii/ServiciiSpeciale/CuratenieVileApartamente";
import CuratenieShowRoomuri from "layouts/pages/servicii/ServiciiSpeciale/CuratenieShowRoomuri";
import CuratenieGaleriiComerciale from "layouts/pages/servicii/ServiciiSpeciale/CuratenieGaleriiComerciale";
import CuratenieFabriciDepoziteHale from "layouts/pages/servicii/ServiciiSpeciale/CuratenieFabriciDepoziteHale";
import CuratenieDupaEvenimente from "layouts/pages/servicii/ServiciiSpeciale/CuratenieDupaEvenimente";
import CuratenieCentreDeAfaceri from "layouts/pages/servicii/ServiciiSpeciale/CuratenieCentreDeAfaceri";
import CuratenieBirouriSedii from "layouts/pages/servicii/ServiciiSpeciale/CuratenieBirouriSedii";
import CuratenieInWeekend from "layouts/pages/servicii/ServiciiSpeciale/CuratenieInWeekend";
import CuratenieCliniciCabineteMedicale from "layouts/pages/servicii/ServiciiSpeciale/CuratenieCliniciCabineteMedicale";

import toateTarifele from "data/servicii/toateTarifele.json";

const routes = [
    {
        name: "Acasă",
        route: "/",
        component: <Homepage />,
        icon: <Icon>home</Icon>,
    },
    {
        name: "Des-Spre noi",
        route: "/despre-noi-curatenie",
        component: <DesSpreNoi />,
        icon: <Icon>read_more</Icon>,
    },
    {
        name: "Galerie",
        route: "/galerie",
        component: <GalleryPage />,
        icon: <Icon>photo_library</Icon>,
    },
    {
        name: "Blog",
        route: "/blog",
        component: <BlogList />,
        icon: <Icon>article</Icon>,
    },
    {
        name: "Contact",
        route: "/contact-curatenie",
        component: <Contact />,
        icon: <Icon>info</Icon>,
    },
    {
        name: "Sună-ne",
        href: "tel:+40730407322",
        icon: <Icon>call</Icon>,
    },
    {
        name: "Curățenie",
        icon: <Icon>cleaning_services</Icon>,
        keepOpen: true,
        collapse: [
            {
                name: "Curățenie Post Construcție",
                route: "/curatenie-post-construct",
                component: <CurateniePostConstruct />,
            },
            {
                name: "Curățenie Generală",
                route: "/curatenie-generala",
                component: <CuratenieGenerala />,
            },
            {
                name: "Curățenie de întreținere",
                route: "/curatenie-de-intretinere",
                component: <CuratenieIntretinere />,
            },
            {
                name: "Curățarea suprafețelor vitrate",
                route: "/curatare-geamuri-suprafete-vitrate",
                component: <CuratareSuprafeteVitrate />,
            },
            {
                name: "Curățare mochete/covoare",
                route: "/curatare-mochete",
                component: <CuratareMocheteCovoare />,
            },
            {
                name: "Curățarea pardoselilor",
                route: "/curatare-pardoseli",
                component: <CuratareaPardoselilor />,
            },
            {
                name: "Tratamente pardoseli",
                route: "/intretinere-si-tratamente-aplicate-pentru-pardoseli",
                component: <TratamentePardoseli />,
            },
        ],
    },
    {
        name: "Servicii",
        route: "/tarife",
        icon: <Icon>business_center</Icon>,
        keepOpen: true,
        collapse: [
            {
                name: "Curățenie vile/apartamente",
                route: "/curatenie-vile-apartamente",
                component: <CuratenieVileApartamente />,
            },
            {
                name: "Curățenie birouri/sedii",
                route: "/curatenie-birouri-firme-spatii-comerciale",
                component: <CuratenieBirouriSedii />,
            },
            {
                name: "Curățenie pentru centre de afaceri",
                route: "/curatenie-centre-de-afaceri",
                component: <CuratenieCentreDeAfaceri />,
            },
            {
                name: "Galerii comerciale & showroom-uri",
                route: "/curatenie-galerii-comerciale",
                component: <CuratenieGaleriiComerciale />,
            },
            {
                name: "Spații exterioare și parcări",
                route: "/curatenie-showroom",
                component: <CuratenieShowRoomuri />,
            },
            {
                name: "Curățenie fabrici, depozite, hale",
                route: "/curatenie-fabrici-depozite-hale",
                component: <CuratenieFabriciDepoziteHale />,
            },
            {
                name: "Curățenie după evenimente",
                route: "/curatenie-dupa-petreceri-evenimente",
                component: <CuratenieDupaEvenimente />,
            },
            {
                name: "Curățenie în weekend pentru firme",
                route: "/curatenie-in-weekend",
                component: <CuratenieInWeekend />,
            },
            {
                name: "Curățenie clinici și cabinete",
                route: "/curatenie-clinici-cabinete-medicale",
                component: <CuratenieCliniciCabineteMedicale />,
            },
        ],
    },
    {
        name: "Tarife",
        route: "/tarife",
        component: <Tarife list={toateTarifele} />,
        icon: <Icon>attach_money</Icon>,
    },
];

export default routes;
